export const drawer = { label: "Públicos", href: "/publicos" };
